import { RestClient } from '../lib/RestClient'

class MensagemService extends RestClient {
  constructor() {
    super('mensagem')
  }
  //mensagem/{id}/participante
  async mensagensNaoLidas(idMensagem, params = {}) {
    const response = await this.request.get(`${idMensagem}/participante`, {
      params
    })
    return response.data
  }
  async mensagemEnviadas(id, params = {}) {
    const response = await this.request.get(`${id}/listar`, {
      params
    })
    return response.data
  }
  async enviar(dados, params = {}) {
    const response = await this.request.post(`web/enviar`, dados, {
      params
    })
    return response
  }
  async desativar(id, selectedEscola) {
    const response = await this.request.put(`desativar/${id}`, {
      escola: selectedEscola
    })
    return response.data
  }
  async desativarMensagem(id, selectedEscola) {
    const response = await this.request.put(`mensagem/desativar/${id}`, {
      escola: selectedEscola
    })
    return response.data
  }

  async tornarAdmin(idParticipante, selectedEscola) {
    const response = await this.request.put(`/admin/${idParticipante}`, {
      escola: selectedEscola
    })
    return response.data
  }
  async desativarParticipante(id, selectedEscola) {
    const response = await this.request.put(`desativar/participante/${id}`, {
      escola: selectedEscola
    })
    return response.data
  }
  async exibirComunicacaoAluno(id, params = {}) {
    const response = await this.request.get(`aluno/${id}`, {
      params
    })
    return response.data
  }
  async exibirComunicacaoResponsavel(id, params = {}) {
    const response = await this.request.get(`responsavel/${id}`, {
      params
    })
    return response.data
  }
  async exibirEscola(id, params = {}) {
    const response = await this.request.get(`escola/${id}`, {
      params
    })
    return response.data
  }
  async getParticipantes(id, params = {}) {
    const response = await this.request.get(`notparticipante/search/${id}`, {
      params
    })
    return response.data
  }
  async getParticipantesDoGrupo(id, params = {}) {
    const response = await this.request.get(`search/${id}`, {
      params
    })
    return response.data
  }
  async adicionarParticipante(id, participantes, params = {}) {
    const response = await this.request.put(
      `participante/${id}`,
      participantes,
      {
        params
      }
    )
    return response.data
  }
}
export const Mensagem = new MensagemService()
